import { ListSubheader, MenuItem } from "@mui/material";
import { groupBy, orderBy } from "lodash-es";
import { useMemo } from "react";

export function useSheetMenu(sheetData, currentSheetIds = []) {
  const menuList = useMemo(() => {
    if (!sheetData?.length) return [];

    const grouped = groupBy(sheetData, s => s.parent || "");
    const entries = orderBy(Object.entries(grouped), [
      groupEntry => groupEntry[0].toLowerCase(),
    ]);

    return entries.flatMap(([parent, sheets]) => {
      const menuItems = orderBy(sheets, [
        sheet => sheet.title.toLowerCase(),
      ]).map(sheet => (
        <MenuItem
          key={sheet.id}
          value={sheet.id}
          style={{
            display: currentSheetIds.some(id => id === sheet.id)
              ? "none"
              : undefined,
          }}
        >
          {sheet.title}
        </MenuItem>
      ));

      const hiddenSubHead = menuItems.every(
        m => m.props?.style?.display === "none"
      );

      return [
        !hiddenSubHead && <ListSubheader key={parent}>{parent}</ListSubheader>,
        menuItems,
      ];
    });
  }, [sheetData, currentSheetIds]);

  return menuList;
}
